import React, { useState, useEffect, useCallback } from 'react';
import Iframe from 'react-iframe';
import { generateURLAffichage } from '../tools/fonctions';
import Filtre from '../components/layout/Filtre';
import { subscribe, unsubscribe } from '../tools/eventDispatcher';

import { collection, getDocs } from 'firebase/firestore';
import { db } from '../config/fbConfig';

const AffichageRapport = () => {
  const [metabaseKey, setMetabaseKey] = useState('');
  const [url, setUrl] = useState(null);
  const [error, setError] = useState(null);
  const [nomRapport, setNomRapport] = useState(null);
  const [secteur, setSecteur] = useState(null);
  const [agence, setAgence] = useState(null);

  const generateURL = useCallback((currentKey) => {
    const {
      nomRapport: localNomRapport,
      typeRapport,
      numRapport,
      Secteur: localSecteur,
      Agence: localAgence,
      dateDeb,
      dateFin,
      nomParamSecteur,
      nomParamAgence,
      dateParamDeb,
      dateParamFin
    } = window.localStorage;

    const keyToUse = currentKey || metabaseKey;

    if (localNomRapport && keyToUse) {
      generateURLAffichage(
        typeRapport,
        numRapport,
        localSecteur,
        localAgence,
        dateDeb,
        dateFin,
        nomParamSecteur,
        nomParamAgence,
        dateParamDeb,
        dateParamFin,
        keyToUse
      )
        .then(generatedUrl => {
          setUrl(generatedUrl);
          setError(null);
        })
        .catch(err => setError(err));
    }
  }, [metabaseKey]);

  useEffect(() => {
    const fetchMetabaseKey = async () => {
      try {
        const snapshot = await getDocs(collection(db, 'metabase'));
        let key = '';

        snapshot.forEach(doc => {
          key = doc.data().key;
        });

        setMetabaseKey(key);
        generateURL(key);
      } catch (err) {
        setError(err);
      }
    };

    fetchMetabaseKey();
  }, []);

  useEffect(() => {
    const handleStorageChange = ({ key, value }) => {
      if (key === 'localStorage') {
        const { nomRapport: newNomRapport, Secteur: newSecteur, Agence: newAgence } = value;

        if (
          newNomRapport !== nomRapport ||
          newSecteur !== secteur ||
          newAgence !== agence
        ) {
          setNomRapport(newNomRapport);
          setSecteur(newSecteur);
          setAgence(newAgence);
          generateURL();
        }
      }
    };

    subscribe('localStorageChange', handleStorageChange);

    return () => {
      unsubscribe('localStorageChange', handleStorageChange);
    };
  }, [nomRapport, secteur, agence, generateURL]);

  return (
    <div className="rapport m-0 bg-white w-100 d-inline-block">
      <Filtre />

      {error && <div className="error">Erreur : {error.message}</div>}

      {!url && !error && <div className="loading">Chargement...</div>}

      {url && (
        <Iframe
          url={url}
          position="absolute"
          width="100%"
          height="86.8%"
          top="0"
          left="0"
          frameBorder="0"
        />
      )}

      {!url && !error && !window.localStorage.nomRapport && !metabaseKey && (
        <div className="no-rapport">Veuillez sélectionner un rapport</div>
      )}
    </div>
  );
};

export default AffichageRapport;
